import React, {useMemo} from 'react';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
  useThesaurusEditSceneExtensionCore,
} from 'sceneExtensions';
import {BulkUpdateNewSceneCore} from './BulkUpdateNewSceneCore';

export const BulkUpdateNewScene: React.FC = () => {
  const codelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();

  const thesaurusEditExtension = useThesaurusEditSceneExtensionCore({
    enableDeactivatedValues: true,
  });
  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore();
  const extensions = useMemo(
    () => [thesaurusEditExtension, linkedValueSearchExtension],
    [linkedValueSearchExtension, thesaurusEditExtension],
  );

  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <BulkUpdateNewSceneCore />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
